import { z } from 'zod';

export const YesNo = z.enum(['y', 'n']);

export type YesNo = z.infer<typeof YesNo>;
